// Setup the Scene
export const Colors = {
    red: 0xf25346,
    white: 0xd8d0d1,
    brown: 0x59332e,
    pink: 0xf5986E,
    brownDark: 0x23190f,
    blue: 0x68c3c0,
    green: 0x497022
};
